<template>
  <div style="position:relative" class="pointer" @click="goToDetail">
    <div v-if="!record.active" class="count-down">{{countDown}}</div>
    <div v-bind:class="!record.active ? 'close': ''">
      <div class="record-head">
        <div class="record-left">
          <span class="chatclass" v-bind:class="record.TradeType == 1 ? 'up':'down'">
            <v-icon class="sajz" v-bind:class="record.TradeType == 1 ? 'up':'down'">{{symbol}}</v-icon>
            <b>
              <span v-if="record.TradeType == 1">BUY</span>
              <span v-else>SELL</span>
            </b>
          </span>
          <span class="text-grey">
            |
            <span class="user-name">{{record._creator.username}}</span>
            |
            {{openTime}}
            |
             <v-tooltip v-if="record._prepare" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" color="#4dbac0" class="mr-1">hourglass_empty</v-icon>
              </template>
              <span>prepared trade</span>
            </v-tooltip>

            <v-tooltip v-if="record._entryLevel" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" color="#4dbac0" class="mr-1">calendar_view_day</v-icon>
              </template>
              <span>trade in zone</span>
            </v-tooltip>
          </span>
          <div class="record-body">
            <b>{{record.Symbol.user}}</b>
            |
            {{Math.abs(record.Quantity)}}
            <span v-if="Math.abs(record.Quantity) > 1">pcs</span>
            <span v-else>pc</span>
            |
            Price:
            {{record.AverageEntryPrice.toFixed(2)}}
            <div style="width-full">
            <v-btn
            class="mt-1"
              x-small
              v-bind:color="record.OpenProfitLoss > 0 ? '#79C04D': (record.OpenProfitLoss < 0 ?'#E62163' : '#808F9C')"
            >${{record.OpenProfitLoss.toFixed(2)}}</v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="record-right">
        <span @click="routeUser()" class="pointer hover">
        <Avatar v-if="record._creator.avatar != null" class="timeline-avatar" :src="`https://tradeinpool.com/upload/${record._creator.avatar}.png`" :size="40"></Avatar>
        <Avatar v-else class="timeline-avatar" :username="record._creator.username" :size="40"></Avatar>
        </span>
    
        <div class="record-menu">
          <v-menu right bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon color="#B6C1CB">more_vert</v-icon>
              </v-btn>
            </template>

            <v-list class="my-vlist" dense>
              <v-list-item class="my-vlistitem">
                <v-list-item-title class="my-vlistitemtitle">
                  <v-icon class="menu-icons">thumb_up</v-icon>Like
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="my-vlistitem">
                <v-list-item-title class="my-vlistitemtitle">
                  <v-icon class="menu-icons">reply</v-icon>Reply
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="my-vlistitem">
                <v-list-item-title class="my-vlistitemtitle" @click="routeUser()">
                  <v-icon class="menu-icons">account_circle</v-icon>User Profile
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="my-vlistitem">
                <v-list-item-title class="my-vlistitemtitle">
                  <v-icon class="menu-icons">message</v-icon>Message
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Avatar from "vue-avatar";
var moment = require("moment-timezone");
export default {
  components: {
    Avatar
  },
  props: ["record"],
  data() {
    return {
      countDown: 10,
      setOpacity: "open",
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.Timestamp, this.$store.getters.timezone)
        .fromNow()
    };
  },
  methods: {
    goToDetail() {
      return this.$router.push({ path: "/trades/" + this.record._creator.username +"/"+ this.record.openTimestamp});
    },
    routeUser() {
      return this.$router.push({path: "/user/"+this.record._creator.username});
    }
  },
  filters: {
    absolute: function(value) {
      if (!value) return "";
      value = Math.abs(value);
      return value;
    }
  },
  mounted() {
    if (this.record.TradeType == 1) {
      this.symbol = "trending_up";
    } else {
      this.symbol = "trending_down";
    }
    // updating record time
    setInterval(() => {
      var value = this.record.createdAt;
      this.fromNow = moment.tz(value, this.$store.getters.timezone).fromNow();
    }, 1000);
  },
  watch: {
    "record.active": function(newVal) {
      if (!newVal) {
       var myTimer = setInterval(() => {
          this.countDown -= 1;
          if(this.countDown <= 1)
          clearInterval(myTimer);
        }, 1000);
      }
    }
  },
  computed: {
    openTime() {
      var value = this.record.createdAt;
      return moment.tz(value, this.$store.getters.timezone).format("HH:mm");
    },

    qtyReturned() {
      if (this.record.Quantity) return this.record.Quantity;
      else return this.record.EntryQuantity;
    },
    statusReturned() {
      if (this.record.Status == "close") return "Closed";
      else return "";
    },

    resultColor() {
      if (
        this.record.Action == "close" ||
        this.record.Action == "open" ||
        this.record.Action == "update"
      ) {
        if (this.record.OpenProfitLoss > 0) {
          return "#79C04D";
        } else {
          return "#E62163";
        }
      } else {
        return null;
      }
    },
    priceReturned() {
      if (this.record.Action == "close") {
        return `Close at: ${this.record.AverageExitPrice.toFixed(2)}`;
      } else if (
        this.record.Action == "open" ||
        this.record.Action == "update"
      ) {
        return `Open at: ${this.record.AverageEntryPrice.toFixed(2)}`;
      } else return null;
    },
    colorReturned() {
      if (this.record.OpenProfitLoss > 0) {
        return "#79C04D";
      } else if (this.record.OpenProfitLoss < 0) {
        return "#E62163";
      } else {
        return "#808F9C";
      }
    }
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}
.count-down{
  position: absolute;
  right:0;
}
</style>
